export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAILURE';   
export const ADD_ITEM = 'ADD_ITEM';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';


export const LOGOUT = 'LOGOUT';  // Add this
